import { c as _c } from "react/compiler-runtime";
import React, { useState, useCallback } from 'react';
import { colorBrand } from 'styles/layout/colors';
import IconMapMarker from 'components/icons/IconMapMarker';
import avo from 'analytics/avo';
import { storeUrlSlugMapping } from 'commons/ShowroomStaticData';
import useProductCardContext from 'data-hooks/useProductCardContext';
import ProductCardShowroomModal from './ProductCardShowroomModal';

// Create array of stores in storeUrlSlugMapping which include path
const storesWithPaths = Object.entries(storeUrlSlugMapping).map(([storePath, store]) => ({
  ...store,
  path: storePath
}));
const getStoreData = ({
  slug
}) => {
  if (slug) {
    return storesWithPaths.find(store => store?.slug === slug);
  }
  return null;
};
const ProductCardOnDisplayInShowroomSingle = () => {
  const $ = _c(20);
  const productCardContextData = useProductCardContext();
  const [modalOpen, setModalOpen] = useState(false);
  const slug = productCardContextData?.onDisplayInShowroomSlug;
  let t0;
  if ($[0] !== slug) {
    t0 = getStoreData({
      slug
    });
    $[0] = slug;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const storeData = t0;
  const path = storeData?.path;
  const showroomData = storeData?.showroom;
  let t1;
  if ($[2] !== modalOpen || $[3] !== path || $[4] !== showroomData) {
    t1 = () => {
      if (!modalOpen) {
        avo.ctaClicked({
          text: `On display in ${showroomData.name}`,
          targetUrl: path,
          cta: "Retail Store",
          component: "Side Panel",
          location: "PDP"
        });
      }
      setModalOpen(!modalOpen);
    };
    $[2] = modalOpen;
    $[3] = path;
    $[4] = showroomData;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const toggleModal = t1;
  if (!showroomData) {
    return null;
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="text-xs font-bold text-gray-light2">On display in </span>;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span><IconMapMarker height={12} width={12} color={colorBrand} /></span>;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== showroomData.name) {
    t4 = <span className="text-xs font-bold text-brand hover:cursor-pointer hover:no-underline flex space-x-2 items-center">{t3}<span> {showroomData.name}</span></span>;
    $[8] = showroomData.name;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4 || $[11] !== toggleModal) {
    t5 = <button className="flex md:flex-row md:items-center flex-col items-start text-xs font-bold text-brand cursor-pointer bg-transparent border-0 pb-[5px] text-left max-[767px]:pt-0 max-[767px]:pr-0 max-[767px]:pb-[5px] max-[767px]:pl-[5px]" onClick={toggleModal} type="button" aria-label="Open Showroom">{t2}{t4}</button>;
    $[10] = t4;
    $[11] = toggleModal;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setModalOpen(false);
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== modalOpen || $[15] !== showroomData) {
    t7 = <ProductCardShowroomModal data={showroomData} onClose={t6} isOpen={modalOpen} />;
    $[14] = modalOpen;
    $[15] = showroomData;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t5 || $[18] !== t7) {
    t8 = <div className="text-xs font-bold text-brand cursor-pointer bg-transparent border-0 pb-[5px] text-left max-[767px]:pt-0 max-[767px]:pr-0 max-[767px]:pb-[5px] max-[767px]:pl-[5px]">{t5}{t7}</div>;
    $[17] = t5;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};
export default ProductCardOnDisplayInShowroomSingle;